// extracted by mini-css-extract-plugin
module.exports = {"close":"index_close_1zVMy"};